import React, { useState } from "react";
import { Check, X, CalendarDays } from "lucide-react";

export const SURVEYOR_MILESTONES = [
  ["surveyor_viewing_requested_date", "Surveyor requested"],
  ["surveyor_viewing_date", "Viewing date"],
  ["surveyor_viewing_completed_date", "Survey completed"],
];
const dmy = (iso) => (iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : "Not set");

function Milestone({ k, label, value, onChange, editing, setEditing, last }) {
  const done = !!value;
  const open = editing === k;
  return (
    <li className="flex sm:flex-col sm:items-center sm:flex-1 min-w-0 relative" data-testid={`timebar-${k}`}>
      {!last && <span className={`absolute sm:hidden left-[11px] top-6 bottom-[-12px] w-px ${done ? "bg-rose-400/60" : "bg-slate-700"}`} aria-hidden />}
      {!last && <span className={`hidden sm:block absolute top-3 left-1/2 right-[-50%] h-px ${done ? "bg-rose-400/60" : "bg-slate-700"}`} aria-hidden />}
      <button type="button" onClick={() => setEditing(open ? null : k)} data-testid={`timebar-dot-${k}`} aria-label={`${label} ${dmy(value)}`}
        className={`relative z-10 w-6 h-6 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${done ? "bg-rose-400 border-rose-300 text-slate-950" : open ? "bg-[#151D2E] border-rose-400" : "bg-[#151D2E] border-slate-600 hover:border-rose-400"}`}>
        {done && <Check className="w-3.5 h-3.5" strokeWidth={3} />}
      </button>
      <button type="button" onClick={() => setEditing(open ? null : k)} className="ml-3 sm:ml-0 sm:mt-2 text-left sm:text-center min-w-0 group" data-testid={`timebar-label-${k}`}>
        <div className="text-[11px] font-semibold text-slate-300 leading-tight">{label}</div>
        <div className={`font-mono-num text-sm mt-0.5 group-hover:underline ${done ? "text-slate-50" : "text-slate-500"}`} data-testid={`timebar-date-${k}`}>{dmy(value)}</div>
      </button>
      {open && (
        <div className="ml-9 sm:ml-0 mt-2 flex items-center gap-1.5 rounded-lg border border-slate-700 bg-[#0B0F17] p-1.5 sm:absolute sm:top-full sm:left-1/2 sm:-translate-x-1/2 sm:z-20 sm:mt-1 shadow-xl shadow-black/50" data-testid={`timebar-editor-${k}`}>
          <CalendarDays className="w-4 h-4 text-slate-500 shrink-0" />
          <input type="date" value={value || ""} onChange={(e) => onChange(e.target.value)} autoFocus data-testid={`timebar-input-${k}`} className="h-8 rounded-md bg-slate-900 border border-slate-700 px-2 text-sm text-slate-100 font-mono-num [color-scheme:dark]" />
          <button type="button" onClick={() => onChange("")} disabled={!value} title="Clear" data-testid={`timebar-clear-${k}`} className="h-8 px-2 rounded-md text-xs text-slate-400 hover:text-rose-300 disabled:opacity-40"><X className="w-3.5 h-3.5" /></button>
          <button type="button" onClick={() => setEditing(null)} data-testid={`timebar-done-${k}`} className="h-8 px-2.5 rounded-md bg-rose-500 text-slate-950 text-xs font-bold">Done</button>
        </div>
      )}
    </li>
  );
}

export default function SurveyorTimebar({ form, setForm }) {
  const [editing, setEditing] = useState(null);
  const n = SURVEYOR_MILESTONES.filter(([k]) => form[k]).length;
  return (
    <div data-testid="surveyor-timebar">
      <ol className="flex flex-col gap-4 sm:flex-row sm:gap-0 sm:items-start sm:pb-1 relative">
        {SURVEYOR_MILESTONES.map(([k, l], i) => <Milestone key={k} k={k} label={l} value={form[k]} onChange={(v) => setForm(k, v)} editing={editing} setEditing={setEditing} last={i === SURVEYOR_MILESTONES.length - 1} />)}
      </ol>
      <p className="text-[11px] text-slate-500 mt-3 sm:mt-5" data-testid="timebar-note"><span className="font-mono-num text-slate-400">{n}/3</span> recorded · tap a milestone to set or clear its date. Dates never change the claim stage — use “Change stage” above.</p>
    </div>
  );
}
